import { useState } from 'react';

import { faTimesCircle } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import styles from '../styles/code.module.scss';
import { CodeT } from 'typesRoot/code.type';
import { useAppDispatch, useAppSelector } from '@config/hooks';
import { DiscountTypeE } from 'typesRoot/discount.enum';
import { resetPromoCode } from '@redux/actions/basketActions';
import { checkIsSalesManagoEnabled } from '@salesManago/helpers';
import { salesManagoUpdatePromoCode } from '@salesManago/events/shopCart';
import { getServerConfig } from '@features/general/generalSlice';
import { getBasket } from '@redux/selectors/basketSelector';
import { getSelectedCity } from '@redux/selectors/summaryReducer.selectors';
import { getOneOffsSelectedFees } from '@features/orderForm/stepShoppingCart/redux/oneOffSideOrders.selector';

type Props = {
  code: CodeT;
  isFirstCode?: boolean;
  isThereSecondCode?: boolean;
};

const ActiveCode = ({ code }: Props) => {
  const dispatch = useAppDispatch();

  const { companyId, salesManago, serverUrl } = useAppSelector(getServerConfig);
  const basket = useAppSelector(getBasket);
  const selectedCity = useAppSelector(getSelectedCity);
  const selectedFees = useAppSelector(getOneOffsSelectedFees);

  const [isCloseHovered, setIsCloseHovered] = useState(false);

  const { code: codeName, discount, discountType } = code;

  return (
    <div className={styles['code']}>
      <p className={styles['name']}>{codeName}</p>

      {discount && (
        <p className={styles['discount']}>{`-${discount}${
          discountType === DiscountTypeE.TOTAL ? ' zł' : '%'
        }`}</p>
      )}

      <FontAwesomeIcon
        className={isCloseHovered ? styles['icon--hover'] : styles['icon']}
        icon={faTimesCircle}
        onClick={() => {
          dispatch(resetPromoCode());

          if (checkIsSalesManagoEnabled(salesManago)) {
            salesManagoUpdatePromoCode(
              '',
              basket[0],
              selectedCity,
              selectedFees,
              'Usunięcie promoCode',
              serverUrl,
              salesManago,
              companyId
            ).catch(e => {
              console.log(e, 'e');
            });
          }
          dispatch(resetPromoCode());
        }}
        onMouseEnter={() => setIsCloseHovered(true)}
        onMouseLeave={() => setIsCloseHovered(false)}
      />
    </div>
  );
};

export default ActiveCode;
